/* IntelApps — Insights Page */
import React, { useEffect } from 'react';
import Header from '../parts/Header.js';
import Footer from '../parts/Footer.js';
import DiscussCTA from '../parts/Discuss.js';

const INSIGHTS = [
  {
    id: 1,
    title: 'Building Production-Ready AI Applications',
    excerpt: 'How we go from prototype to production with LLMs, including evals, observability, and cost optimization.',
    category: 'AI',
    date: 'Apr 2026',
    readTime: '12 min read',
    img: '/assets/portfolio/aiagent.png',
  },
  {
    id: 2,
    title: 'Reducing App Size by 70%',
    excerpt: 'Techniques we used to ship a feature-rich React Native app under 20MB.',
    category: 'Mobile',
    date: 'Mar 2026',
    readTime: '8 min read',
    img: '/assets/portfolio/doordash.png',
  },
 
];

export default function InsightsPage() {
  useEffect(() => { document.title = 'IntelApps — Insights'; }, []);

  return (
    <>
      <Header />
      <main>
        <section className="page-hero">
          <div className="container page-hero-grid">
            <div>
              <span className="eyebrow">Insights</span>
              <h1>Field notes from the studio.</h1>
              <p className="page-hero-sub">What we&apos;ve learned building AI products, mobile apps, web platforms, and DApps.</p>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="insights-grid">
              {INSIGHTS.map((post) => (
                <article key={post.id} className="insight-card">
                  <img src={post.img} alt={post.title} />
                  <div className="insight-card-body">
                    <span className="insight-category">{post.category}</span>
                    <h3 className="insight-title">{post.title}</h3>
                    <p className="insight-excerpt">{post.excerpt}</p>
                    <div className="insight-meta">
                      <span>{post.date}</span>
                      <span>·</span>
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
        <DiscussCTA />
      </main>
      <Footer />
    </>
  );
}
